import type { QuickSendSelectionItem, StoreProduct } from "~/src/types/productSelection"
import type { Address } from "~/src/types/address"

type Errors = {
  errors: { [key: string]: string }
}

export type QuickSendSelection = {
  id?: number
  kind: QuickSendSelectionKind
  storeProduct?: StoreProduct
}

export enum QuickSendSelectionKind {
  None = "none",
  Chosen = "added_as_option",
  Gifted = "included_gift",
}

export type QuickSend = {
  id: number
  kind: QuickSendKind
  emailBody: string
  notecardMessage: string
  bulkUploadCsv: string
  preferenceCollector: PreferenceCollector
  orderRecipients: OrderRecipient[]
  selections: QuickSendSelectionItem[]
  errors: { [key: string]: string }
  baseErrors: string[]
  bulkUploadCsvErrors: string[]
  internationalAllowed?: boolean
  restrictedCountryCodes: string[]
}

export enum QuickSendKind {
  Standard = "standard",
  Surprise = "surprise",
}

export type PreferenceCollector = {
  id: number
}

export type OrderRecipient = {
  id: number
  name: string
  company: string
  email: string
  senderName: string
  senderEmail: string
  use: "email" | "link"
  recipientUrl?: string
  address?: Address & Errors
}

export type Collectionable = {
  id: number
  name: string
  photoLargeUrl: string
  photoMediumUrl: string
  photoThumbUrl: string
  photoXlargeUrl: string
}

export type CollectionItem = {
  id: number
  collectionableType: "StoreProduct" | "StoreKit"
  collectionableId: number
  collectionable: Collectionable
}
